import { ChangeEvent, useMemo } from "react"
import { DropDownForm } from "src/components/common/form/DropdownForm"
import { InputForm } from "src/components/common/form/input/InputForm"
import { SysCodeDto } from "src/dtos/code/sysCodeDto"
import { defaultMST3010_R01Dto, MST3010_R01Dto } from "./Dto_MST3010_R01"
import { useCommonCodeStore } from "src/store/useCommonCodeStore"
import { useMST3010_R01Store } from "./Store_MST3010_R01"
import { BRDiv } from "src/components/common/common"
import { toNumberSafe } from "src/utils/type/typeUtil"
import { WareHouseDto } from "src/dtos/warehouse/wareHouseDto"
import { CompanyDto } from "src/dtos/company/companyDto"
import { InfoCodeSearchFieldConfig } from "src/types/info-form"
import useUiuxStore from "src/store/useUiuxStore"
import { useInfoFormEvents } from "src/hooks/useInfoFormEvents"
import { CodeForm } from "src/components/common/form/CodeForm"
import { getEmployeeList } from "src/apis/employeeApi"


interface Props {
  data?: MST3010_R01Dto
  outWarehouseCdListToUse: WareHouseDto[]
  inWarehouseCdListToUse: WareHouseDto[]
  badWarehouseCdListToUse: WareHouseDto[]
  plcListToUse: SysCodeDto[] // "연동 PLC ID" 드롭다운 옵션 (minorCd = plc_id, codeNm = PLC명)
  defaultMST3010_R01Row: MST3010_R01Dto
}

export const Info_MST3010_R01 = ({ data, outWarehouseCdListToUse, inWarehouseCdListToUse, badWarehouseCdListToUse, plcListToUse, defaultMST3010_R01Row }: Props) => {

	const { setCodeSearchModalProps } = useUiuxStore();
	const { 
		yesNoList, 
		compCdList, 
		workProcessList,
		wmsCdList,
		warehouseCdList
	} = useCommonCodeStore();

	// zustand 스토어에서 상태 및 setter 가져오기
	const { selectedMST3010_R01, editMST3010_R01, setEditMST3010_R01 } = useMST3010_R01Store();

	const inWarehouseHandleFoucsId = 'inWarehouseCd_search';
	const outWarehouseHandleFoucsId = 'outWarehouseCd_search';
	const badWarehouseHandleFoucsId = 'badWarehouseCd_search';
	const workEmpInfoHandleFoucsId = 'workEmpInfoInput';
	
    // Info 폼 코드 검색 필드 설정
    const infoFieldConfigs_inWarehouse: InfoCodeSearchFieldConfig[] = useMemo(() => [
        {
            fieldName: 'inWarehouse',
            category: '입고창고',
            focusId: inWarehouseHandleFoucsId,
            responseMapping: {
				warehouseCd: 'inWarehouse',
				warehouseNm: 'inWarehouseNm',
            },
            extraFilter: () => ({
                logicCenter: editMST3010_R01?.logicCenter || ''
            })
        }
    ], [editMST3010_R01?.logicCenter]);
    const infoFieldConfigs_outWarehouse: InfoCodeSearchFieldConfig[] = useMemo(() => [
        {
            fieldName: 'outWarehouse',
            category: '출고창고',
            focusId: outWarehouseHandleFoucsId,
            responseMapping: {
                warehouseCd: 'outWarehouse',
                warehouseNm: 'outWarehouseNm',
            },
            extraFilter: () => ({
                logicCenter: editMST3010_R01?.logicCenter || ''
            })
        }
    ], [editMST3010_R01?.logicCenter]);
    const infoFieldConfigs_badWarehouse: InfoCodeSearchFieldConfig[] = useMemo(() => [
        {
            fieldName: 'badWarehouse',
            category: '불량창고',
            focusId: badWarehouseHandleFoucsId,
            responseMapping: {
				warehouseCd: 'badWarehouse',
				warehouseNm: 'badWarehouseNm',
            },
            extraFilter: () => ({
                logicCenter: editMST3010_R01?.logicCenter || ''
            })
        }
    ], [editMST3010_R01?.logicCenter]);
	const infoFieldConfigs: InfoCodeSearchFieldConfig[] = [
		{
			fieldName: 'workEmpNo',
			category: '담당자',
			focusId: workEmpInfoHandleFoucsId,
			responseMapping: {
				empNo : 'workEmpNo',
				empNm : 'workEmpNm'
			},
			searchFunction: async (code: string) => {
				const employeeResponse = await getEmployeeList('all');
				return employeeResponse.data.data.find(value => value.empNo === code);
			}
		},	
	];

	// Info 폼 이벤트 훅 사용
	const { getFieldHandlers: getFieldHandlers_inWarehouse } = useInfoFormEvents({
		editData: editMST3010_R01,
		setEditData: setEditMST3010_R01,
		defaultData: defaultMST3010_R01Row,
		infoFieldConfigs: infoFieldConfigs_inWarehouse,
		setCodeSearchModalProps,
		formName: 'MST3010_R01'
	});
	const { getFieldHandlers: getFieldHandlers_outWarehouse } = useInfoFormEvents({
		editData: editMST3010_R01,
		setEditData: setEditMST3010_R01,
		defaultData: defaultMST3010_R01Row,
		infoFieldConfigs: infoFieldConfigs_outWarehouse,
		setCodeSearchModalProps,
		formName: 'MST3010_R01'
	});
	const { getFieldHandlers: getFieldHandlers_badWarehouse } = useInfoFormEvents({
		editData: editMST3010_R01,
		setEditData: setEditMST3010_R01,
		defaultData: defaultMST3010_R01Row,
		infoFieldConfigs: infoFieldConfigs_badWarehouse,
		setCodeSearchModalProps,
		formName: 'MST3010_R01'
	});
	const { getFieldHandlers: getFieldHandlers_workEmp } = useInfoFormEvents({
		editData: editMST3010_R01,
		setEditData: setEditMST3010_R01,
		defaultData: defaultMST3010_R01Row,
		infoFieldConfigs: infoFieldConfigs,
		setCodeSearchModalProps,
		formName: 'MST3010_R01'
	});

	// input/select 값 변경 핸들러
	const handleChange = (e: ChangeEvent<HTMLInputElement> | ChangeEvent<HTMLSelectElement>) => {
		const { name, value } = e.target;
		// 숫자로 저장하는 입력 필드 목록. 연동 PLC ID(plcId)는 문자열이라 포함하지 않는다(옛 plcAddress 제거)
		const numberFieldNames = ['displaySeq', 'dayStartCount', 'lotStartCount'];
		const numberValue = toNumberSafe(value) ?? 0;
		let result = {
			...editMST3010_R01,
			[name]: numberFieldNames.includes(name) ? numberValue : value
		}

		if(name === 'logicCenter') {
			result.inWarehouse = '';
			result.inWarehouseNm = '';
			result.outWarehouse = '';
			result.outWarehouseNm = '';
			result.badWarehouse = '';
			result.badWarehouseNm = '';
		}

		setEditMST3010_R01({
			...result,
		});
	}

	// 렌더링
	return(
		<div className="w-full h-full overflow-y-auto flex border border-gray-300">
			<div className="w-[100%] h-full flex flex-wrap content-start p-[12px]">
				
				<InputForm title="작업장코드" 		value={editMST3010_R01.workplaceCd}		editable={selectedMST3010_R01 === undefined}	name="workplaceCd"		onChange={handleChange} />
				<InputForm title="공정명" 		value={editMST3010_R01.workplaceNm} 	editable={true} 								name="workplaceNm"		onChange={handleChange} />
				<DropDownForm<CompanyDto> 
					title="사업장"
					data={compCdList}
					value={editMST3010_R01.compCd}
					name="compCd" 
					initLabelLess={true}
					onChange={handleChange} />
					<BRDiv />
				<DropDownForm<SysCodeDto> 
					title="공정유형"
					data={workProcessList}
					value={editMST3010_R01.workProcess}
					name="workProcess" 
					initLabelLess={true}
					onChange={handleChange} />
				<DropDownForm<SysCodeDto> 
					title="사용여부"
					data={yesNoList}
					value={editMST3010_R01.useYn}
					name="useYn" 
					initLabelLess={true}
					onChange={handleChange} />
				<InputForm title="표시순서" 		value={editMST3010_R01.displaySeq.toString()}	editable={true} name="displaySeq"		onChange={handleChange} />
					<BRDiv />

				<DropDownForm<SysCodeDto> 
					title="지시여부"
					data={yesNoList}
					value={editMST3010_R01.orderYn}
					name="orderYn" 
					initLabelLess={true}
					onChange={handleChange} />
				<DropDownForm<SysCodeDto> 
					title="바코드발행"
					data={yesNoList}
					value={editMST3010_R01.barcodePrint}
					name="barcodePrint" 
					initLabelLess={true}
					onChange={handleChange} />
				<InputForm title="라벨코드" 		value={editMST3010_R01.levelCd}	editable={true} name="levelCd"		onChange={handleChange} />
					<BRDiv />

				<DropDownForm<SysCodeDto> 
					title="외주관리"
					data={yesNoList}
					value={editMST3010_R01.outsourcingYn}
					name="outsourcingYn" 
					initLabelLess={true}
					onChange={handleChange} />
				<DropDownForm<SysCodeDto> 
					title="스캔이력여부"
					data={yesNoList}
					value={editMST3010_R01.scanHistory}
					name="scanHistory" 
					initLabelLess={true}
					onChange={handleChange} />
				<DropDownForm<SysCodeDto> 
					title="불량관리"
					data={yesNoList}
					value={editMST3010_R01.faultyYn}
					name="faultyYn" 
					initLabelLess={true}
					onChange={handleChange} />
					<BRDiv />
				<DropDownForm<SysCodeDto> 
					title="기본물류"
					data={wmsCdList}
					value={editMST3010_R01.logicCenter}
					name="logicCenter" 
					initLabelLess={true}
					onChange={handleChange} />
					
				<CodeForm
					label="입고담당자"
					value={editMST3010_R01?.workEmpNo || ""}
					custNmValue={editMST3010_R01?.workEmpNm || ""}
					editable={true}
					handleFoucsId={workEmpInfoHandleFoucsId}
					name="workEmpNo"
					handleChange={getFieldHandlers_workEmp('workEmpNo').onChange}
					onDoubleClick={getFieldHandlers_workEmp('workEmpNo').onDoubleClick}
					onKeyDown={getFieldHandlers_workEmp('workEmpNo').onEnterKeyDown}/>
				<BRDiv />
					
				<CodeForm
					label="출고창고"
					value={editMST3010_R01?.outWarehouse || ""}
					custNmValue={editMST3010_R01?.outWarehouseNm || ""}
					editable={true}
					handleFoucsId={outWarehouseHandleFoucsId}
					name="outWarehouse"
					handleChange={getFieldHandlers_outWarehouse('outWarehouse').onChange}
					onDoubleClick={getFieldHandlers_outWarehouse('outWarehouse').onDoubleClick}
					onKeyDown={getFieldHandlers_outWarehouse('outWarehouse').onEnterKeyDown}
				/>
				<CodeForm
					label="입고창고"
					value={editMST3010_R01?.inWarehouse || ""}
					custNmValue={editMST3010_R01?.inWarehouseNm || ""}
					editable={true}
					handleFoucsId={inWarehouseHandleFoucsId}
					name="inWarehouse"
					handleChange={getFieldHandlers_inWarehouse('inWarehouse').onChange}
					onDoubleClick={getFieldHandlers_inWarehouse('inWarehouse').onDoubleClick}
					onKeyDown={getFieldHandlers_inWarehouse('inWarehouse').onEnterKeyDown}
				/>
				<CodeForm
					label="불량창고"
					value={editMST3010_R01?.badWarehouse || ""}
					custNmValue={editMST3010_R01?.badWarehouseNm || ""}
					editable={true}
					handleFoucsId={badWarehouseHandleFoucsId}
					name="badWarehouse"
					handleChange={getFieldHandlers_badWarehouse('badWarehouse').onChange}
					onDoubleClick={getFieldHandlers_badWarehouse('badWarehouse').onDoubleClick}
					onKeyDown={getFieldHandlers_badWarehouse('badWarehouse').onEnterKeyDown}
				/>
					<BRDiv />
				{/* 연동 PLC ID 선택 — mst_workplace.plc_id 저장. 맨 위 '미연동'(빈 값) 선택 시 연결 해제. 옛 "실적연동 Address" 입력 칸 대체(6차 요청 슬라이드 4) */}
				<DropDownForm<SysCodeDto>
					title="연동 PLC ID"
					data={plcListToUse}
					value={editMST3010_R01.plcId ?? ''}
					name="plcId"
					initLabel="미연동"
					onChange={handleChange}
					wrapperOption={{
						wrapperStyle: "w-[300px] min-w-[300px] mr-[10px] mb-[5px]",
						titleStyle: "w-[110px] min-w-[110px] text-left pl-0",
						inputStyle: "w-[190px] min-w-[190px]",
					}}
				/>
				<InputForm title="일일 실적 시작량" value={editMST3010_R01.dayStartCount ?? 0} editable={true} name="dayStartCount" onChange={handleChange} numericCommitOnBlur={true} />
				<InputForm title="Lot 실적 시작량" value={editMST3010_R01.lotStartCount ?? 0} editable={true} name="lotStartCount" onChange={handleChange} numericCommitOnBlur={true} />
					<BRDiv />
				<InputForm title="비고" 			value={editMST3010_R01.remark || ''}	editable={true} name="remark"			onChange={handleChange} />
					<BRDiv />
			</div>
		</div>
	)
}
